import { render, staticRenderFns } from "./Fatherhood.vue?vue&type=template&id=e8b40a60&scoped=true&"
import script from "./Fatherhood.vue?vue&type=script&lang=js&"
export * from "./Fatherhood.vue?vue&type=script&lang=js&"
import style0 from "./Fatherhood.vue?vue&type=style&index=0&id=e8b40a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b40a60",
  null
  
)

export default component.exports